import { AssetAmount } from "@sundaeswap/asset";
import { TooltipItem } from "chart.js";
import { useMemo } from "react";
import { DEFAULT_DECIMALS } from "../../../../constants/cardano.constants";
import { IAssetMetaData } from "../../../../types/Asset.types";
import { getAssetName } from "../../../../utils/assets.utils";
import { numberI18n } from "../../../../utils/number-format";
import { TTasteTestVestingScheduleChartConfig } from "../types";

export const useTasteTestVestingScheduleChartTooltips = (
  chartConfig: TTasteTestVestingScheduleChartConfig
) => {
  const { activeTasteTest, currentLocale, t, vestingData } = chartConfig;
  return useMemo(
    () => ({
      title: (tooltipItem: TooltipItem<"line">[]) => {
        const { dataIndex, dataset, datasetIndex } = tooltipItem[0];
        const itemData = activeTasteTest?.vestingSchedule?.[datasetIndex];
        // @ts-expect-error --> x is not a property of ChartDataSets but it is in the data object
        const releaseDate = dataset?.data?.[dataIndex]?.x || "";
        return `${t?.("detail.projectDetails.vestingSchedule.chart.tooltips.title", {
          asset: getAssetName(activeTasteTest?.asset as unknown as IAssetMetaData),
          releaseDate,
          title: itemData?.label,
        })}`;
      },
      label: (tooltipItem: TooltipItem<"line">) => {
        const { dataIndex, dataset } = tooltipItem;
        const vestingDataForAddress = vestingData?.filter(
          (vesting) => vesting.address === dataset.label
        );
        const vestingAmount = vestingDataForAddress?.[dataIndex]?.amount || "0";
        const address = dataset.label;
        const assetAmount = new AssetAmount(vestingAmount, activeTasteTest?.asset);
        return `${t?.("detail.projectDetails.vestingSchedule.chart.tooltips.label", {
          address,
          amount: `${numberI18n(
            assetAmount.value.toNumber(),
            {
              minimumFractionDigits: 0,
              maximumFractionDigits: activeTasteTest?.asset?.decimals ?? DEFAULT_DECIMALS,
            },
            currentLocale
          )} ${getAssetName(activeTasteTest?.asset as unknown as IAssetMetaData)}`,
        })}`;
      },
      footer: (tooltipItems: TooltipItem<"line">[]) => {
        const totalAmount = tooltipItems.reduce((acc, item) => {
          return acc + (item.raw as { y: number }).y;
        }, 0);
        return `${t?.("detail.projectDetails.vestingSchedule.chart.tooltips.footer")}: ${numberI18n(
          totalAmount,
          {
            minimumFractionDigits: 0,
            maximumFractionDigits: activeTasteTest?.asset?.decimals ?? DEFAULT_DECIMALS,
          },
          currentLocale
        )} ${getAssetName(activeTasteTest?.asset as unknown as IAssetMetaData)}`;
      },
    }),
    [activeTasteTest, currentLocale, t]
  );
};
